export enum DeviceFilter {
  MONITORED = 'MONITORED',
  IN_PROVISIONING = 'IN_PROVISIONING',
  NO_MODELS = 'NO_MODELS',
  ONLINE = 'ONLINE',
}
